<template>
  <wrapper>
    <template slot="navigation">
      <menu-point icon="calendar" to="dashboard">Veranstaltungen</menu-point>
      <menu-point icon="shopping-cart" to="orders">Bestellungen</menu-point>
      <menu-point icon="file-invoice-dollar" to="accounting">Abrechnung</menu-point>
      <menu-point icon="cog" to="account">Einstellungen</menu-point>
    </template>

    <template slot="page">
      <router-view />
    </template>
  </wrapper>
</template>

<script>
import MenuPoint from "@/components/MenuPoint";
import BackPoint from "@/components/BackPoint";
import Wrapper from "@/components/Wrapper";

export default {
  components: {
    MenuPoint,
    BackPoint,
    Wrapper
  }
};
</script>